import React from "react";
import * as S from "./GeneralView.style";

const mockAvatars = [
  "https://i.pravatar.cc/150?img=1",
  "https://i.pravatar.cc/150?img=5",
  "https://i.pravatar.cc/150?img=8",
  "https://i.pravatar.cc/150?img=9",
  "https://i.pravatar.cc/150?img=12"
];

const cardsData = [
  {
    id: "critico",
    title: "Pacientes con Riesgo de Navegación Crítico",
    subtitle: "Pacientes en crisis inminente o con alertas directas que amenazan críticamente la continuidad de su tratamiento",
    warning: "Es posible que estos pacientes no finalicen el resultado clínico esperado.",
    className: "critical",
    countStr: "+39"
  },
  {
    id: "alto",
    title: "Pacientes con Riesgo de Navegación Alto",
    subtitle: "Pacientes con barreras severas o múltiples que exigen gestión intensiva y acompañamiento frecuente para evitar el abandono",
    className: "high",
    countStr: ""
  },
  {
    id: "medio",
    title: "Pacientes con Riesgo de Navegación Medio",
    subtitle: "Pacientes con barreras identificadas que requieren coordinación activa de recursos para no interrumpir su cuidado.",
    className: "medium",
    countStr: "+255"
  },
  {
    id: "bajo",
    title: "Pacientes con Riesgo de Navegación Bajo",
    subtitle: "Pacientes con barreras mínimas o manejables de forma independiente, que requieren un monitoreo preventivo.",
    className: "low",
    countStr: "+255"
  }
];

const GeneralView = ({ onSelectView }) => {
  return (
    <S.GeneralContainer>
      <div className="cards-wrapper">
        {cardsData.map((card) => (
          <div 
            className={`risk-card ${card.className}`}
            key={card.id}
            onClick={() => onSelectView(card.id)}
          >
            <div className="card-info">
              <div className="title">{card.title}</div>
              <div className="subtitle">{card.subtitle}</div>
              {card.warning && (
                <div className="warning-text">
                  <i className="warning-text__icon zaia-i-alert"></i> {card.warning}
                </div>
              )}
            </div>
            <div className="card-actions">
              <div className="avatar-group">
                {mockAvatars.map((url, i) => (
                  <img src={url} alt={`avatar-${i}`} key={i} className="avatar" />
                ))}
                {card.countStr && <span className="extra-count">{card.countStr}</span>}
              </div>
              <button 
                className="view-all"
                onClick={() => onSelectView(card.id)}
              >
                Ver todos los pacientes
              </button>
            </div>
          </div>
        ))}
      </div>
    </S.GeneralContainer>
  );
};

export default GeneralView;
